// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"9e6ce4f1","470":"93b45d3f","589":"6e2d26d8","840":"6ec5674e","926":"9cd965b5"}[chunkId] + ".chunk.js";
};